export const GROUP_NAME = 'input-text'
